import { jsx as _jsx } from "react/jsx-runtime";
import { useRef, useState, useEffect } from "react";
import { HTMLTextTags } from "./helpers/elementGroups.js";
export function InlineTextUI({ value, selected, updateData, close, }) {
    const editorRef = useRef(null);
    const [text, setText] = useState(value);
    function sanitizeText(text) {
        return text.replace(/<[^>]*>?/gm, "");
    }
    function handleContentChange() {
        if (!editorRef.current)
            return value;
        const text = sanitizeText(editorRef.current.textContent || "");
        setText(text);
        return text;
    }
    function onClose() {
        const text = handleContentChange();
        if (text !== value)
            updateData(text);
        close();
    }
    useEffect(() => {
        if (!editorRef.current)
            return;
        editorRef.current.textContent = value;
    }, []);
    return (_jsx("div", { ref: editorRef, onInput: () => setText(editorRef.current?.textContent || ""), onBlur: onClose, className: "Launched__tag-inlineEditor", contentEditable: true, suppressContentEditableWarning: true, "data-empty": text === "", spellCheck: selected }));
}
export const InlineTextRenderer = {
    component: (props) => {
        return _jsx(InlineTextUI, { ...props });
    },
    parentValidator: (el) => {
        return HTMLTextTags.includes(el.nodeName);
    },
    getStaticProperties: (el) => el.textContent || "",
    updateStaticProperties: ({ element, data }) => {
        const textNode = element.firstChild;
        if (!textNode)
            return console.warn("No text node found in element", element);
        textNode.textContent = data;
    },
};
